import { Directive, ElementRef, AfterViewInit, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appResponsiveHtml]'
})
export class ResponsiveHtmlDirective implements AfterViewInit {
  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngAfterViewInit() {
    // Aguarda o conteúdo ser inserido no DOM
    this.applyResponsiveStyles();
  }

  ngAfterContentChecked() {
    // Caso o conteúdo do innerHTML seja alterado dinamicamente
    this.applyResponsiveStyles();
  }

  private applyResponsiveStyles() {
    // Seleciona todas as imagens dentro do conteúdo injetado
    const images = this.el.nativeElement.querySelectorAll('img');
    images.forEach((img: HTMLImageElement) => {
      this.renderer.setStyle(img, 'max-width', '100%');
      this.renderer.setStyle(img, 'height', 'auto');
    });
  }
}